
import { combineReducers } from 'redux';
import { imageList } from './imageList';

export default combineReducers({
    imageList
});



// WEBPACK FOOTER //
// ./reducers/index.js